/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Enum for bench search modes.
 */
export enum BenchMode {
  BENCHES = "benches",
  NO_BENCH = "no_bench",
  BOTH = "both",
}
